module.exports = "<div class=\"header\">\n  <h1 class=\"site-title\">{{title}}</h1>\n  <h2>{{userName}}</h2>\n</div>\n<div class=\"body\">\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = 1